import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class productReview {
	static classname = 'product-review';

	constructor($review) {
		this.$review = $review;

		this.bindEvents();
	}

	get id() {
		return this.$review.data('review_id');
	}

	get $voting() {
		return this.$review.find('.review__voting');
	}

	get vote_url() {
		return this.$voting.data('url');
	}

	get $form_container() {
		return this.$review.find('.review__reply-form:first');
	}

	get $form() {
		return this.$form_container.find('.review-reply-form');
	}

	get is_visible_reply_form() {
		return !this.$form_container.hasClass('review__reply-form_disabled');
	}

	set is_visible_reply_form(state) {
		return this.$form_container.toggleClass('review__reply-form_disabled', !state);
	}

	vote(vote) {
		$.post(this.vote_url, {
			review_id: this.id,
			vote: vote
		}, response => {
			if (response.status === 'ok') {
				const $up = this.$voting.find('.review__voting-vote_up');
				const $down = this.$voting.find('.review__voting-vote_down');
				this.$voting.find('.review__voting-vote_selected').removeClass('review__voting-vote_selected');
				if (response.data.user_vote == 1) {
					$up.addClass('review__voting-vote_selected');
				} else if(response.data.user_vote == -1) {
					$down.addClass('review__voting-vote_selected');
				}
				$up.find('.review__voting-vote-counter').html(response.data.likes_count);
				$down.find('.review__voting-vote-counter').html(response.data.dislikes_count);
			} else {
				alert(response.error);
			}
		});
	}

	bindEvents() {
		const self = this;

		this.$review.find('.review__reply-btn:first').on('click', () => {
			if (!window.product_review_reply_form) {
				return;
			}

			if (!this.$form_container.hasClass('review__reply-form_init')) {
				this.$form_container.html(window.product_review_reply_form);
				this.$form_container.find('.review-reply-form__parent-id').val(this.id);
				this.$form_container.addClass('review__reply-form_init');

				this.bind$FormEvents();
			}

			this.is_visible_reply_form = !this.is_visible_reply_form;
		});

		this.$review.find('.review__voting-vote').on('click', function() {
			self.vote($(this).hasClass('review__voting-vote_up') ? 1 : -1);
		});

		const $show_all_btn = this.$review.find('> .review__replies > .review__replies-show-all-btn');
		$show_all_btn.on('click', function() {
			$(this).closest('.review__replies').find('> .review__reply_hidden').removeClass('review__reply_hidden');
			$show_all_btn.hide();
		});
	}

	bind$FormEvents() {
		this.$form.on('success', () => {
			this.$form.find('input:not(.review-reply-form__parent-id), textarea').val('');
			this.updateHasReplies();
			this.is_visible_reply_form = false;
		});

		this.$form.on('cancel', () => {
			this.is_visible_reply_form = false;
		});
	}

	updateHasReplies() {
		const $replies = this.$review.children('.review__replies').children();
		this.$review.toggleClass('review_has-replies', $replies.length > 0);
	}
}
